import { saveListSDG, saveCountSDG } from "../Infrastructure/SDG.store";
import { getSDGLogic } from "./SDG.logic";

export async function getSDG(params) {
  const { count, resources: repositorySdgs } = await getSDGLogic(params);
  saveListSDG(repositorySdgs);
  saveCountSDG(count);
}
